/** 后台会员管理「会员级别」完整选项（秘书处可指定高于申请表的可选范围） */
export const ADMIN_MEMBER_LEVEL_OPTIONS = [
  '会长单位',
  '监事长单位',
  '荣誉会长、总顾问单位',
  '名誉会长单位',
  '常务副会长单位',
  '副会长单位',
  '理事单位',
  '名誉理事单位',
  '监事单位',
  '法律顾问',
  '会员单位',
  '名誉会员单位',
]

export function toMemberLevelSelectOptions(levels = ADMIN_MEMBER_LEVEL_OPTIONS) {
  return (levels || []).map((v) => {
    const text = String(v || '').trim()
    return text ? { value: text, label: text } : null
  }).filter(Boolean)
}
